<template>
    <div class="jom-abstract" id="abstract">
      <div v-for="item in abstracts" v-if="item.lang == lang || layout == 'rc' && isBilingual"
           :class="{'justify-align' : item.lang == 'zh', 'left-align' : item.lang == 'en'}">
        <h2 v-if="item.lang == 'zh'">摘要</h2>
        <h2 v-else>Abstract</h2>
        <component :is="'jo' + item2.name" v-for="item2 in item.data" v-bind:key="item2.index" v-bind:data="item2.data"></component>
      </div>
      <div v-if="abstractGraphic" id="abstract-graphic">
        <h3 v-if="lang == 'zh'">图文摘要</h3>
        <h3 v-else>Graphic Abstract</h3>
        <div id="graphical" v-if="abstractGraphic.graphic && abstractGraphic.graphic.length>0">
          <img v-for="(item,index) in abstractGraphic.graphic" :src="item.big" v-bind:style="'max-width:'+'80%'" @click="showBigPic(index)">
          <el-dialog width="inherit" top="0" custom-class="jom-bigPicDialog" :visible.sync="isShowBigPic"  @open="closePosition" :show-close="false">
            <img :src="abstractGraphic.graphic[current].big" :style="{ 'max-height': picHeight + 'px', 'max-width': picWidth + 'px' }">
          </el-dialog>
        </div>
        <component :is="'jo' + item.name" v-for="item in abstractGraphic.data" v-bind:key="item.index" v-bind:data="item.data"></component>
      </div>
    </div>
</template>

<script>
    export default {
      data() {
          return {
            lang: this.ARTICLE.defaultlang,
            abstracts: this.ARTICLE.abstracts,
            abstractGraphic: this.ARTICLE.abstractgraphic,
            picHeight: 'inherit',
            picWidth: 'inherit',
            isShowBigPic: false,
            current:0
          }
      },
      props : [
          'language'
      ],
      created() {
        if (this.language !== undefined && this.language !== '') {
          this.lang = this.language;
        }
      },
      mounted() {
          if (this.layout !== 'rc'){
            this.$bus.on('currentLang', (lang) => {
              this.lang = lang;
            })
          }
      },
      methods:{
        showBigPic (index) {
          this.current = index;
          this.isShowBigPic = true
          this.picHeight = document.documentElement.clientHeight * 0.8
          this.picWidth = document.documentElement.clientWidth * 0.9
        },
        closePosition() {
          let _this = this
          _this.$nextTick(() => {
            $('.el-dialog__body').on('click', function () {
              _this.isShowBigPic = false
            })
            $(_this.$refs.bigPic).on('click', function (e) {
              e.stopPropagation()
            })
          })
        }
      },
    }
</script>

<style lang="scss" scoped>
    .jom-abstract{
      h2{
        background: none;
        color: #333;
      }
    }
    #abstract-graphic{
      border: 1px solid #b5b5b5;
      padding: 0px 20px;
      margin: 20px auto 0px auto;
      width: calc(100% - 40px);
      #graphical{
        img{
          margin: 10px auto;
          display: block;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/abstract/abstract.vue